import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import CheckboxField from '../../../../BaseModule/Components/Form/Components/CheckboxField/CheckboxField';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.CHECKBOX }>;
}

const WizardCheckbox: React.FC<Props> = ({ item }) => {
	return (
		<CheckboxField
			name={item.key}
			label={item.title}
			isRequired={item.settings?.required}
		/>
	);
};

export default WizardCheckbox;
